import { useTranslation } from '@supply-mover-2-0/web-ui';
import type { JSX } from 'react';

/**
 * Generic 404 page used when the portal can't be found or the URL is invalid.
 * Intentionally minimal — no details about why the page wasn't found,
 * just a clean dead-end so the user knows to check their URL.
 */
export function NotFoundPage(): JSX.Element {
	const { t } = useTranslation();

	return (
		<div className="min-h-dvh flex items-center justify-center bg-brand-page-bg px-4">
			<div className="text-center">
				<h1 className="text-6xl font-bold text-disabled mb-4">{t('404')}</h1>
				<p className="text-lg text-brand-muted mb-2">{t('Page not found')}</p>
				<p className="text-sm text-brand-muted">
					{t(
						'The page you are looking for does not exist or is no longer available.',
					)}
				</p>
			</div>
		</div>
	);
}
